import React, { useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import styles from './Admin.module.css';

export default function Admin() {
  const [password, setPassword] = useState('');
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  
  const loginUrl = '/api/admin/login';
  const checkAuthPath = '/api/admin/check-auth';
  const clientSitePath = '/admin-panel';

useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(checkAuthPath, {
          method: 'GET',
          credentials: 'include',
        });
        const data = await response.json();
        if (data.isAuthenticated) {
          navigate(clientSitePath, { replace: true });
        }
      } catch (error) {
        console.error('Auth check error:', error);
      }
    };
    checkAuth();
  }, [navigate, clientSitePath, checkAuthPath]);

    

  const handleLogin = async () => {
    if (isRequestInProgress) return;
    setIsRequestInProgress(true);
    setError('');

    try {
      const response = await fetch(loginUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
        credentials: 'include',
      });
      if (response.ok) {
        navigate(clientSitePath, { replace: true });
      } else if (response.status === 429) {
        setError('Too many login attempts. Try again in 20 minutes.');
      } else {
        setError('Invalid password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Server error. Please try again later.');
    } finally {
      setIsRequestInProgress(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !isRequestInProgress) {
      handleLogin();
    }
  };

  return (
    <div>
      <div id="login-section" className={styles.loginContainer}>
        <div className={styles.loginPanel}>
          <h2 className={styles.panelH2}>Admin Login</h2>
          <label htmlFor="password" className={styles.srOnly}>Password</label>
          <input
            className={styles.panelInput}
            id="password"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError('');
            }}
            onKeyPress={handleKeyPress}
          />
          <button
            className={styles.panelButton}
            id="login-button"
            onClick={handleLogin}
            disabled={isRequestInProgress}
          >
            Login
          </button>
          {error && <p id="login-error" className={styles.error}>{error}</p>}
        </div>
      </div>
    </div>
  );
}